import { ResourcesCostSummarySection } from '../summary/ResourcesCostSummarySection';
import { UnverifiedClocksSection } from '../unverifiedClocks/UnverifiedClocksSection';
import { EmployeePresenceSection } from './EmployeePresenceSection';

export const ClockInSection = () => {
  return (
    <div className="flex flex-col gap-5 w-full">
      <EmployeePresenceSection />
        <ResourcesCostSummarySection />
      <UnverifiedClocksSection />
    </div>
  );
};
